import type { ConversationDigestApiModel as ConversationSummary } from "@noa/api-core";
import { useTranslation } from "react-i18next";
import { useDeleteConversationWithReset } from "@noa/ui";
import { Dialog, Text } from "~/components/ui";

type DeleteConversationModalProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  conversation: ConversationSummary | null;
};

export function DeleteConversationModal({ isOpen, setIsOpen, conversation }: DeleteConversationModalProps) {
  const { t } = useTranslation("conversation");
  const { deleteConversation, isPending: isDeletingConversation } = useDeleteConversationWithReset();

  const handleConfirm = () => {
    if (!conversation) return;

    deleteConversation(conversation.session_id, {
      onSuccess: () => setIsOpen(false),
    });
  };

  return (
    <Dialog
      title={t("deleteModal.title")}
      open={isOpen}
      onOk={handleConfirm}
      onCancel={() => setIsOpen(false)}
      okText={t("common:delete")}
      okButtonProps={{ danger: true }}
      cancelText={t("common:cancel")}
      confirmLoading={isDeletingConversation}
    >
      <Text>
        {t("deleteModal.bodyPrefix")} <Text strong>{conversation?.summary}</Text> ?
      </Text>
    </Dialog>
  );
}
